import React from 'react';
import { CoverageCheckup } from '@frontman/coverage-checkup';
import '@frontman/coverage-checkup/scss/tailwind.css';
import '@ramsey-design-system/radio-tile/dist/radio-tile.css';
import '@ramsey-design-system/select/dist/select.css';
import '@ramsey-design-system/form-field/dist/form-field.css';
import '@ramsey-design-system/tokens/dist/tokens.css';
import '@ramsey-design-system/checkbox-tile/dist/checkbox-tile.css';
import { saveProgress } from '../../../../lib/learnClient';
import { ActionItem } from '../../../../types';
import { AutoFillableFields } from './utils/formatAutoFillableFields';

interface CoverageCheckupTemplateProps {
  actionItem: any;
  completeFpuActionItem: Function;
  autoFillableFields: AutoFillableFields;
}

const onComplete = async (item: ActionItem, onCompleteFunc: Function) => {
  // Make the "save" API call
  await saveProgress({
    course_id: item.course_id,
    lesson_id: item.lesson_id,
    action_id: item.id,
    data: { complete: true },
    template: item.template,
  });
  // Sets the checkmark after a successful save
  onCompleteFunc(item);
};

export function CoverageCheckupTemplate({
  actionItem,
  completeFpuActionItem,
  autoFillableFields,
}: CoverageCheckupTemplateProps) {
  return (
    <CoverageCheckup
      completeFpuActionItem={() =>
        onComplete(actionItem, completeFpuActionItem)
      }
      actionItem={actionItem}
      autoFillableFields={autoFillableFields}
    />
  );
}
